<div class="xux-tooltip" [style.borderColor]="color" [style.--tooltip-border-color]="color">
  <div class="tooltip-label">{{label | translate}}</div>
  <div class="tooltip-count">{{count}}</div>
</div>
